<template>
  <div>
    <b-row>
      <b-col>
        <h3>{{ user.first_name}}, <br> <small class="text-gray-dark">benvenuto in CWM!</small></h3></b-col>
      <b-coL>
        <b-img :src="user.customer.logo_url" height="100" right />
      </b-coL>
    </b-row>


    <b-card no-body class="mt-5" v-if="otherPlans.length">
      <b-row no-gutters>
        <b-col cols="1" class="text-center align-middle p-3" style="background-color: hsl(1,100%,60%);">
          <img src="../../assets/icons/icn-collaboration.svg" class="my-3"/>
        </b-col>
        <b-col align-v="center" class="p-3 border-bottom">
          <h3 class="m-0">Assistenza</h3>
          <span class="m-0" style="color: #939393;">
            Assistenza tecnica evoluta per i tuoi dispositivi digitali.
          </span>
        </b-col>
        <b-col align-v="center" align="right" class="p-3 border-bottom">
          <b-btn variant="outline-danger" size="lg" class="mt-2" :to="{ name: 'Richieste', params: { create: true } }">
            <i class="fas fa-file-alt mr-2"></i> Nuova Richiesta
          </b-btn>
        </b-col>
      </b-row>

      <b-row no-gutters v-for="sub in otherPlans" :key="sub.id">
        <b-col cols="1" class="text-center align-middle p-3" style="background-color: hsla(24,100%,54%,0.50)"></b-col>
        <b-col cols="7" class="p-3">
          <strong>
            {{ sub.plan.name }}
          </strong> <br>
          <span class="m-0" style="color: #939393;">
            {{ sub.plan.description }}
          </span>

          <h5 class="mt-1">
            <b-badge v-if="sub.plan.has_assistance">ASSISTENZA</b-badge>
            <b-badge v-if="sub.plan.has_mdm">MDM</b-badge>
            <b-badge v-if="sub.plan.has_kasko">KASKO</b-badge>
            <b-badge v-if="sub.plan.has_security">SICUREZZA</b-badge>
            <b-badge v-if="sub.plan.has_onsite">ONSITE</b-badge>
          </h5>
        </b-col>
        <b-col class="p-3">
          <p>
            Validità: <br>
            {{ sub.date_start | moment('DD MMMM YYYY') }}
            <span>&#8594;</span>
            {{ sub.date_expiration | moment('DD MMMM YYYY') }}
          </p>
        </b-col>
        <b-col class="p-3">
          Stato
          <h2>
            {{ sub.status | uppercase }}
          </h2>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import EventBus from '@/services/eventbus';
  import Schedule from '@/components/plans/Schedule';
  import {mapActions, mapState, mapGetters} from 'vuex';

  export default {
    name: 'Piani',
    components: {
      Schedule,
    },
    data: () => ({
      user: {},
      plans: [],
      devices: [],

      plansFields: [
        {
          key: 'code',
          label: 'Piano',
          sortable: true,
          formatter: (value, key, row) => `${row.plan.code}: ${ row.plan.name }`
        },
        {
          key: 'devices_max',
          label: 'Dispositivi inclusi',
          sortable: true,
          formatter: (value, key, row) => `${row.plan.devices_max}`
        },
        {
          key: 'ticket_per_cycle',
          label: 'Interventi inclusi',
          sortable: true,
          formatter: (value, key, row) => `${row.ticket_per_cycle}`
        },
        {key: 'status', label: 'Stato', sortable: true},
        {
          key: 'date_start',
          label: 'Attivazione',
          sortable: true,
          formatter: (value, key, row) => value ? moment(value).format('DD/MM/YYYY') : '-'
        },
        {
          key: 'date_expiration',
          label: 'Scadenza',
          sortable: true,
          formatter: (value, key, row) => value ? moment(value).format('DD/MM/YYYY') : '-'
        },
      ],
    }),

    computed: {
      otherPlans() {
        return this.plans.filter(p => p.plan.code.indexOf('SKC') < 0 && p.plan.code.indexOf('SKT') < 0)
      },
      ...mapState({
        user: state => state.user,
      }),
    },

    mounted() {
      this.getData();

      EventBus.$on('refresh_data', this.getData);
    },

    methods: {
      async getData() {
        let loader = this.$loading.show();

        const [user, devices, sub] = await Promise.all([
          this.$apiclient.getProfile(),
          this.$apiclient.getDevices(),
          this.$apiclient.getPlans(),
        ]);

        this.user = user;
        this.devices = devices;
        this.plans = this.mergePlansAndTickets(sub.plans, sub.tickets);

        loader.hide();
      },

      mergePlansAndTickets(plans, tickets) {
        const res = [];

        plans.forEach(p => {
          let t = _.find(tickets, function(t) { return t.id === p.id; });
          p.ticket_used = t ? t.ticket_used : 0;
          res.push(p);
        });

        return res;
      },

      startSchedule(category, sub) {
        console.log('Avvio prenotazione', sub);

        EventBus.$emit('schedule', {
          category,
          subcategory: sub.plan.name,
          phone_number: this.user.phone_number,
          email: this.user.email,
          name: this.user.first_name,
          subscription_id: sub.id,
        });
      }
    },
  };

</script>

<style scoped>
  .btn {
    border-radius: 0.6rem;
  }

  .card {
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.1);
  }

</style>



// WEBPACK FOOTER //
// src/pages/AreaRiservata/Piani.vue